import React from 'react';
import clsx from 'clsx';

interface TextInputProps {
  name: string;
  value: string | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const TextInput = ({
  name,
  value,
  onChange,
  placeholder,
  className,
  disabled = false,
}: TextInputProps) => (
  <input
    type="text"
    name={name}
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
    placeholder={placeholder}
    className={clsx(
      'text-neutral-700 placeholder:text-neutral-400',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      'border border-neutral-300 rounded-md p-3',
      className,
    )}
    disabled={disabled}
  />
);
